module.exports = __webpack_public_path__ + "img/h1.3fae9481.png";